// components/Services.jsx
import React from 'react';
import '../styles/Services.css';

const Services = () => {
  const services = [
    {
      id: 1,
      icon: '🌊',
      title: 'Emergency Water Extraction',
      description: '24/7 emergency water removal and extraction services for floods, burst pipes, and storms.',
      tag: '24/7 Available'
    },
    {
      id: 2,
      icon: '💨',
      title: 'Structural Drying',
      description: 'Professional drying of walls, floors, ceilings, and structural elements using industrial equipment.',
      tag: 'Advanced Equipment'
    },
    {
      id: 3,
      icon: '🦠',
      title: 'Mold Remediation',
      description: 'Complete mold inspection, testing, and removal to ensure safe and healthy indoor air quality.',
      tag: 'Certified Team'
    },
    {
      id: 4,
      icon: '🏠',
      title: 'Water Damage Repair',
      description: 'Full restoration of water-damaged properties including drywall, flooring, and structural repairs.',
      tag: 'Expert Craftsmanship'
    },
    {
      id: 5,
      icon: '🚰',
      title: 'Flood Cleanup',
      description: 'Comprehensive flood damage cleanup and restoration for residential and commercial properties.',
      tag: 'Rapid Response'
    },
    {
      id: 6,
      icon: '🔧',
      title: 'Sewage Cleanup',
      description: 'Safe and sanitary sewage backup cleanup, disinfection, and restoration services.',
      tag: 'Biohazard Certified'
    },
    {
      id: 7,
      icon: '💧',
      title: 'Pipe Burst Repair',
      description: 'Emergency pipe burst repair and water damage restoration to prevent further property damage.',
      tag: '24/7 Response'
    },
    {
      id: 8,
      icon: '🏢',
      title: 'Commercial Restoration',
      description: 'Professional water damage restoration for businesses, offices, and commercial properties.',
      tag: 'Business Solutions'
    },
    {
      id: 9,
      icon: '🌪️',
      title: 'Storm Damage Restoration',
      description: 'Complete storm damage restoration including wind, rain, and flood damage repair.',
      tag: 'Insurance Claims'
    }
  ];

  return (
    <section id="services" className="services">
      <div className="services-bg">
        <div className="services-bg-circle services-bg-circle-1"></div>
        <div className="services-bg-circle services-bg-circle-2"></div>
        <div className="services-bg-circle services-bg-circle-3"></div>
      </div>

      <div className="services-container">
        <div className="services-header">
          <span className="services-subtitle">What We Offer</span>
          <h2 className="services-title">
            Professional <span className="services-title-highlight">Water Damage Services</span>
          </h2>
          <p className="services-description">
            From emergency water extraction to complete restoration, our certified team handles it all
            with expertise and care.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div 
              key={service.id} 
              className="services-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="services-card-shine"></div>
              <div className="services-card-icon">{service.icon}</div>
              <h3 className="services-card-title">{service.title}</h3>
              <p className="services-card-description">{service.description}</p>
              <span className="services-card-tag">{service.tag}</span>
            </div>
          ))}
        </div>

        <div className="services-cta">
          <div className="services-cta-content">
            <span className="services-cta-badge">✅ 100% Satisfaction Guaranteed</span>
            <h3 className="services-cta-title">Water Damage Emergency?</h3>
            <p className="services-cta-description">
              Don't wait — water damage gets worse by the minute. Call us now for immediate help!
            </p>
            <div className="services-cta-buttons">
              <button className="services-cta-btn-primary" onClick={() => {
                window.location.href = 'tel:+18334936236';
              }}>
                <span className="services-cta-btn-shine"></span>
                📋 Book Service Now
              </button>
              <a href="tel:+18334936236" className="services-cta-btn-secondary">
                📞 Call Now: +1 (833) 493-6236
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;